import styled from 'styled-components';

export const DimensionPanelWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  margin-top: 2px;
`;
